export default function () {
  var tinyMCE = window.tinyMCE;
  const GMP_AJAX = window.GMP_AJAX;
  var overlayUpload = $(".overlay__upload");
  var uploadMessage = $(".overlay__message h4");
  var tryAgain = $(".overlay__button");

  var gmpText = {
    selector: ".question__answer",
    menubar: false,
    inline: true,
    paste_data_images: false,
    plugins: [
      "image",
      "quickbars",
      "lists",
      "autosave",
      "textpattern",
      "paste",
    ],
    toolbar: false,
    quickbars_insert_toolbar: "image numlist bullist bold italic underline",
    quickbars_selection_toolbar: "numlist bullist bold italic underline",
    textpattern_patterns: [
      { start: "- ", cmd: "InsertUnorderedList" },
      {
        start: "1. ",
        cmd: "InsertOrderedList",
        value: { "list-style-type": "decimal" },
      },
      {
        start: "1) ",
        cmd: "InsertOrderedList",
        value: { "list-style-type": "decimal" },
      },
      {
        start: "a. ",
        cmd: "InsertOrderedList",
        value: { "list-style-type": "lower-alpha" },
      },
      {
        start: "a) ",
        cmd: "InsertOrderedList",
        value: { "list-style-type": "lower-alpha" },
      },
      {
        start: "i. ",
        cmd: "InsertOrderedList",
        value: { "list-style-type": "lower-roman" },
      },
      {
        start: "i) ",
        cmd: "InsertOrderedList",
        value: { "list-style-type": "lower-roman" },
      },
    ],
    setup: function (editor) {
      editor.addShortcut("ctrl+p", "Add image", function () {
        $("#upload").trigger("click");
      });

      // Intercept paste at the DOM level for direct image paste (most reliable)
      editor.on('paste', function(e) {
        var clipboardData = e.clipboardData || window.clipboardData;
        if (clipboardData) {
          // Check for direct image data in clipboard items
          if (clipboardData.items) {
            for (var i = 0; i < clipboardData.items.length; i++) {
              if (clipboardData.items[i].type.indexOf('image') !== -1) {
                e.preventDefault();
                editor.notificationManager.open({
                  text: "Images cannot be pasted. Please use the image button or Ctrl+P to upload.",
                  type: "warning",
                  timeout: 5000,
                });
                return false;
              }
            }
          }

          // Check HTML content for img tags (catches images copied from webpages)
          var htmlContent = clipboardData.getData('text/html');
          if (htmlContent && /<img[^>]*>/i.test(htmlContent)) {
            e.preventDefault();
            // Get plain text version instead and insert that
            var textContent = clipboardData.getData('text/plain');
            if (textContent) {
              editor.insertContent(textContent.replace(/</g, '&lt;').replace(/>/g, '&gt;'));
            }
            editor.notificationManager.open({
              text: "Images cannot be pasted. Please use the image button or Ctrl+P to upload.",
              type: "warning",
              timeout: 5000,
            });
            return false;
          }
        }
      });
    },
    paste_preprocess: function(plugin, args) {
      // Check for any img tags (blocks ALL images including external URLs)
      var hasImages = /<img[^>]*>/i.test(args.content);

      if (hasImages) {
        // Strip all image tags
        args.content = args.content.replace(/<img[^>]*>/gi, '');

        var editor = (plugin && plugin.editor) ? plugin.editor : window.tinyMCE && window.tinyMCE.activeEditor;
        if (editor && editor.notificationManager) {
          editor.notificationManager.open({
            text: "Images cannot be pasted. Please use the image button or Ctrl+P to upload.",
            type: "warning",
            timeout: 5000,
          });
        }
      }
    },
    paste_postprocess: function(plugin, args) {
      // Second-pass cleanup for any images that got through
      var imgs = args.node.querySelectorAll('img');
      if (imgs.length > 0) {
        imgs.forEach(function(img) {
          img.remove();
        });
        var editor = (plugin && plugin.editor) ? plugin.editor : window.tinyMCE && window.tinyMCE.activeEditor;
        if (editor && editor.notificationManager) {
          editor.notificationManager.open({
            text: "Images cannot be pasted. Please use the image button or Ctrl+P to upload.",
            type: "warning",
            timeout: 5000,
          });
        }
      }
    },
    file_picker_callback: function (callback, value, meta) {
      if (meta.filetype == "image") {
        $("#upload").trigger("click");
        $("#upload").on("change", function () {
          var file = this.files[0];
          overlayUpload.show();
          var formdata = new FormData();
          formdata.append("security", GMP_AJAX.ajax_nonce);
          formdata.append("action", "upload_image");
          formdata.append("image[file]", file);

          $.ajax({
            type: "post",
            url: GMP_AJAX.ajax_url,
            processData: false,
            contentType: false,
            data: formdata,
            success: function (response) {
              try {
                var data = JSON.parse(response);
              } catch (err) {
                uploadMessage.html("Something wen't wrong, please try again.");
                tryAgain.show(200);
                console.log(err);
                return;
              }
              if (data.error) {
                uploadMessage.html(data.message);
                tryAgain.show(200);
              } else {
                callback(data.url + "/" + data.image);
                overlayUpload.hide();
              }
            },
          });
        });
      }
    },
  };

  tryAgain.on("click", function () {
    overlayUpload.hide();
    uploadMessage.html("Uploading");
    setTimeout(function () {
      $("#upload").val("");
      tryAgain.hide();
      jQuery(".tox-dialog__header button").trigger("click");
    }, 100);
  });

  $(document).ready(function () {
    if ($(".question__answer").length < 1) return;
    tinyMCE.init(gmpText);
    $(".question__answer").focus();
  });
}



// WEBPACK FOOTER //
// ./scripts/components/SetupTiny.js